import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Typography } from 'antd';
import React from 'react';
import { Wrapper } from './styles';
import { useNavigate } from 'react-router-dom';

function Header({ title }) {
    const navigate = useNavigate();
    return (
        <Wrapper>
            {/* <div>
                <Dropdown
                    trigger={['click']}
                    menu={{
                        items: [
                            {
                                key: "1",
                                label: "List",
                                onClick: () => {
                                    navigate("/")
                                }
                            },
                            {
                                key: "2",
                                label: "Finance",
                                onClick: () => {
                                    navigate("/finance")
                                }
                            },
                        ]
                    }}
                >
                    <Button>
                        <MenuOutlined />
                    </Button>
                </Dropdown>
            </div> */}
            <div>
                <Typography.Title style={{ margin: 0 }} level={4}>
                    {title}
                </Typography.Title>
            </div>
            {/* <div style={{ marginLeft: "auto" }}>
                <Dropdown
                    trigger={['click']}
                    menu={{
                        items: [
                            {
                                key: "1",
                                label: "LogOut",
                                onClick: () => {
                                    localStorage.removeItem("cars_token");
                                    window.location.reload();
                                }
                            },
                        ]
                    }}
                >
                    <Avatar icon={<UserOutlined />} />
                </Dropdown>
            </div> */}
        </Wrapper>
    )
}

export default Header